// Round platform bed purchase restriction.
//
// A round platform bed is built to carry one of our round mattresses and is not
// sold as standalone furniture, so a cart holding a platform with no round
// mattress must not reach checkout. snippets/round-platform-rule.liquid owns the
// decision and evaluates it server-side from the real cart; this script only
// carries that verdict into the checkout controls after an ajax cart change.
//
// Why a separate file rather than a change to cart-form.js: CartForm is a vendor
// Archetype component pulled from @archetype-themes, and edits there are lost on
// the next component bump. assets/cart-rv-mattress.js layers bundle integrity on
// top the same way, so this follows that pattern.
//
// The footer is not re-rendered on a cart change. CartForm.cartMarkup() replaces
// only [data-products], [data-discounts] and [data-subtotal], so the Check out
// button keeps whatever state Liquid gave it on page load. That is what this
// script fixes: it reads the freshly rendered flag out of the products markup
// and applies it to the footer.
//
// Scope, stated plainly: this is presentation-layer enforcement. It stops the
// paths a customer actually uses -- both Check out buttons, the dynamic wallet
// buttons, and a form submit -- but it cannot stop a hand-built /checkout hit or
// a cart permalink, because a theme has no hook there. Only a Cart or Checkout
// Validation Function can close those, and Shopify Functions cannot be activated
// for this store's plan and app setup.
(function () {
  var SELECTORS = {
    // Rendered by snippets/cart-ajax.liquid, refreshed on every cart change.
    flagSource: '.cart__items[data-round-platform-blocked]',
    wrapper: '[data-checkout-wrapper]',
    checkoutBtn: '.cart__checkout',
    products: '[data-products]'
  };

  // Read the verdict for one cart form. Returns null when this form has no
  // ajax-rendered products markup yet -- on the cart page's first paint the
  // items come straight from section-main-cart.liquid, which carries no flag
  // element. Returning null means "no opinion", so the server-rendered state
  // Liquid already applied is left alone instead of being cleared.
  function blockedStateFor(form) {
    var source = form.querySelector(SELECTORS.flagSource);
    if (!source) return null;
    return source.getAttribute('data-round-platform-blocked') === 'true';
  }

  // Whether checkout is blocked for this form *right now*, as opposed to what a
  // fresh cart render says it should be. Reads the wrapper flag, which Liquid
  // stamps on first paint and applyTo() maintains from then on, so it answers
  // correctly in both phases. blockedStateFor() cannot serve this purpose: it
  // returns null on the cart page's own first render, where the line items come
  // from section-main-cart.liquid and no ajax flag element exists yet.
  function isCurrentlyBlocked(form) {
    var wrapper = form.querySelector(SELECTORS.wrapper);
    return !!wrapper && wrapper.getAttribute('data-checkout-blocked') === 'true';
  }

  function applyTo(form) {
    var blocked = blockedStateFor(form);
    if (blocked === null) return;

    var wrappers = form.querySelectorAll(SELECTORS.wrapper);
    for (var i = 0; i < wrappers.length; i++) {
      if (blocked) {
        wrappers[i].setAttribute('data-checkout-blocked', 'true');
      } else {
        wrappers[i].removeAttribute('data-checkout-blocked');
      }
    }

    var buttons = form.querySelectorAll(SELECTORS.checkoutBtn);
    for (var j = 0; j < buttons.length; j++) {
      buttons[j].disabled = blocked;
      if (blocked) {
        buttons[j].setAttribute('aria-disabled', 'true');
        // CartForm.onSubmit adds this on click and only removes it on the paths
        // it itself aborts. Clearing it here keeps a blocked button from being
        // left spinning forever after a click that never submits.
        buttons[j].classList.remove('btn--loading');
      } else {
        buttons[j].removeAttribute('aria-disabled');
      }
    }
  }

  function forms() {
    var found = [];
    var sources = document.querySelectorAll(SELECTORS.flagSource);
    for (var i = 0; i < sources.length; i++) {
      var form = sources[i].closest('form');
      if (form && found.indexOf(form) === -1) found.push(form);
    }
    return found;
  }

  function applyAll() {
    var list = forms();
    for (var i = 0; i < list.length; i++) applyTo(list[i]);
  }

  // Backstop for the form itself. Bound in the capture phase on document so it
  // runs before CartForm's own bubble-phase submit handler, which would
  // otherwise add its loading class to a submit that is about to be cancelled.
  // A disabled button already prevents the click, so this only catches submits
  // raised another way -- pressing Enter in a quantity field, or a script.
  // It consults the wrapper flag, not the ajax one, so that it is armed on the
  // cart page's first paint too, where there is no ajax flag element yet.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector || !form.querySelector(SELECTORS.checkoutBtn)) return;
      if (!isCurrentlyBlocked(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var notice = form.querySelector('[data-round-platform-notice]');
      if (notice && notice.scrollIntoView) {
        notice.scrollIntoView({ block: 'center' });
      }
    },
    true
  );

  // Every cart re-render funnels through CartForm.cartMarkup(), which empties
  // and refills [data-products]. Watching those containers therefore catches all
  // of it -- quantity change, add to cart, drawer build, bundle reconcile --
  // without having to know which event each path happens to dispatch.
  function observe() {
    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(function () { applyAll(); });
    var containers = document.querySelectorAll(SELECTORS.products);
    for (var i = 0; i < containers.length; i++) {
      observer.observe(containers[i], { childList: true, subtree: true });
    }
  }

  function start() {
    applyAll();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Cheap idempotent belt and braces for the events the theme does dispatch.
  document.addEventListener('cart:updated', applyAll);
  document.addEventListener('ajaxProduct:added', applyAll);
})();
